import React  , { Component } from 'react'

import {  HomeSlider,
          HomeDeals       } from '../../Components/UI/UI'

import {getWeather} from '../../Utility/Utility'

import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'



class SpacielDeals extends Component {

  state = {
   
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,

  }

  componentDidMount () {

    getWeather((Weather)=>{
      
      console.log("Weather", Weather);
      this.setState({
        telAvivWeather : Weather.telAvivWeather,
        waterTemp : Weather.water_temp,
        jerusalemWeather : Weather.jerusalemWeather,
      })

      
    });
    

     
  }
  
  render(){
    return(
      <div className="page align-center page-SpacielDeals">
        <Menu />
        <HomeSlider isHomeSlider={true} waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />
        <HomeDeals />
        <Footer />
      </div>
    )
  }

}



export default SpacielDeals


// WEBPACK FOOTER //
// ./src/Pages/SpacielDeals/SpacielDeals.js